/**
 * Converts degrees to radians.
 *
 * @param {Number} degrees The number in degrees, to convert to radians.
 * @returns A number of radians.
 */
export function toRadians (degrees) {
  return (Math.PI / 180.0) * degrees
}

/**
 * Converts radians to degrees.
 *
 * @param {Number} radians The number in radians, to convert to degrees.
 * @returns A number of degrees.
 */
export function toDegrees (radians) {
  return (180.0 / Math.PI) * radians
}

/**
 * Calculates what percent of the day a millisecond offset represents.
 * @param {Number} elapsedMilliseconds The number of milliseconds since the start time.
 * @returns The percentage of the day that has elapsed.
 */
export function percentOfDay (elapsedMilliseconds) {
  const pctOfDay = elapsedMilliseconds / (60 * 60 * 24 * 1000)
  return pctOfDay
}

/**
 * Converts a string into an identifier.
 * @param {String} stringInput The string to convert to an identifier.
 */
export function identifierFromString (stringInput) {
  if (!stringInput || !stringInput.length) {
    return undefined
  }
  const nonAlphaNumeric = RegExp('^[a-z0-9]')
  return stringInput
    .toLowerCase()
    .split(nonAlphaNumeric)
    .join('')
}
